import * as React from 'react';
import Alert from './Alert';
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
            info: {
                componentStack: '',
            },
        };
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { message, title, description, id, children } = this.props;
        const { error, info } = this.state;
        const mergedTitle = title ?? message;
        const componentStack = info?.componentStack || null;
        const errorMessage = typeof mergedTitle === 'undefined' ? (error || '').toString() : mergedTitle;
        const errorDescription = typeof description === 'undefined' ? componentStack : description;
        if (error) {
            return (React.createElement(Alert, { id: id, type: "error", title: errorMessage, description: React.createElement("pre", { style: { fontSize: '0.9em', overflowX: 'auto' } }, errorDescription) }));
        }
        return children;
    }
}
export default ErrorBoundary;
